// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationDialog_notification__2kI2l"};